/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2025-08-12T15:42:30.819
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import request from '@/plugins/request';

export function listReportRentContractCardInit(data){return request({
url: '/report/api/reportRentContractCard/listReportRentContractCardInit',
method: 'post',
data:data,
});
}


export function listReportRentContractCardByAuthorizations(data){return request({
url: '/report/api/reportRentContractCard/listReportRentContractCardByAuthorizations',
method: 'post',
data:data,
});
}


export function listReportRentContractCard(data){return request({
url: '/report/api/reportRentContractCard/listReportRentContractCard',
method: 'post',
data:data,
});
}


export function getReportRentContractCardCreateInit(){return request({
url: '/report/api/reportRentContractCard/getReportRentContractCardCreateInit',
method: 'post',
});
}


export function getReportRentContractCardEditInit(params){return request({
url: '/report/api/reportRentContractCard/getReportRentContractCardEditInit',
method: 'post',
params:params,
});
}


export function getReportRentContractCardView(params){return request({
url: '/report/api/reportRentContractCard/getReportRentContractCardView',
method: 'post',
params:params,
});
}


export function saveReportRentContractCard(data){return request({
url: '/report/api/reportRentContractCard/saveReportRentContractCard',
method: 'post',
data:data,
});
}


export function deleteReportRentContractCard(params){return request({
url: '/report/api/reportRentContractCard/deleteReportRentContractCard',
method: 'post',
params:params,
});
}


